import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Select from 'component/utils/Select'
import BranchSelectSimple from 'component/branch/BranchSelectSimple'
import { Link } from 'react-router'
import DateRangePicker from 'component/DateRangePicker'

class MostAccessedView extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    top5: PropTypes.array,
    user: PropTypes.object,
    title: PropTypes.string.isRequired,
    type: PropTypes.number.isRequired,
    fetchMenus: PropTypes.func.isRequired,
  }

  state = {
    branchFilter: 0,
    branchArray: [],
    periodFilter: 0,
    customDateRangeString: '',
  }

  handleChange = (event, companyOptions) => {
    const { target } = event

    const { fetchMenus } = this.props

    let { periodFilter } = this.state
    let { branchFilter } = this.state

    if (target.name === 'store') {
      this.setState({ branchFilter: target.value })
      branchFilter = target.value
    } else {
      this.setState({ periodFilter: target.value })
      periodFilter = target.value
    }

    let dtStart = null
    let dtEnd = null

    if (parseInt(periodFilter, 10) !== 0) {
      dtStart = moment().subtract(periodFilter, 'd').format('DD/MM/YYYY')
      dtEnd = moment().format('DD/MM/YYYY')
    }

    let branchArray = []

    // Se for menor do que 3 caracteres sabemos que foi selecionada região
    if (branchFilter.length < 3 && companyOptions) {
      branchArray = companyOptions
        .filter(
          (branch) => parseInt(branch.idRegion, 10) === parseInt(branchFilter, 10)
        )
        .map((branch) => branch.value)
    } else if (branchFilter.length >= 3) {
      branchArray.push(branchFilter)
    } else {
      branchArray = this.state.branchArray
    }

    this.setState({ branchArray })

    if (target.value === 'custom') return

    this.setState({ customDateRangeString: '' })

    fetchMenus({
      idBranches: branchArray,
      dtInicio: dtStart,
      dtFim: dtEnd,
    })
  }

  handleSearch = (dtInicio, dtFim) => {
    const { branchArray: idBranches } = this.state
    const { fetchMenus } = this.props

    this.setState({
      customDateRangeString: `${dtInicio.format('DD/MM/YYYY')} - ${dtFim.format(
        'DD/MM/YYYY'
      )}`,
    })

    fetchMenus({
      idBranches,
      dtInicio: dtInicio.format('DD/MM/YYYY'),
      dtFim: dtFim.format('DD/MM/YYYY'),
    })
  }

  renderItem = (item, index) => {
    const { translate } = this.props

    return (
      <Row key={index}>
        <Col xs={8}>
          <span className='list-item'>{`${index + 1} -`}</span>{' '}
          {translate(item.dsChaveMenu)}
        </Col>
        <Col xs={4} md={3} className='align-right'>
          {`${item.count} (${item.percent}%)`}
        </Col>
      </Row>
    )
  }

  renderEmpty = () => {
    const { translate } = this.props

    return (
      <Col xs={12} className='notification notification-warning'>
        {translate('mobile-update.not-found')}
      </Col>
    )
  }

  render() {
    const { translate, top5, user, title, type } = this.props

    const { periodFilter, branchFilter, customDateRangeString } = this.state

    const periods = [
      { key: 1, label: translate('analytics.last24hours') },
      { key: 6, label: translate('analytics.last7days') },
      { key: 29, label: translate('analytics.last30days') },
      { key: 0, label: translate('analytics.sinceAlways') },
      {
        key: 'custom',
        label: customDateRangeString || translate('analytics.custom'),
      },
    ]

    return (
      <div className='padding full-height'>
        <Row className='daterange-title-container'>
          {periodFilter === 'custom' && (
            <div className='daterange-title'>
              <span>{translate('analytics.custom.daterange')}</span>
              <DateRangePicker
                t={translate}
                onRangeSelect={(dtStart, dtEnd) => {
                  this.handleSearch(dtStart, dtEnd)
                }}
              />
            </div>
          )}
        </Row>

        <Row className='margin-bottom margin-top'>
          <span className='gray-title'>{title}</span>
        </Row>

        <Row className='align-left margin-top-double'>
          {top5 && top5.map(this.renderItem)}

          {top5 && top5.length === 0 && this.renderEmpty()}
        </Row>

        <Row className='margin-top-double filters'>
          <Col xs={5}>
            <Select
              name='period'
              id={`period-${type}`}
              onChange={this.handleChange}
              value={periodFilter}
            >
              {periods.map((period) => (
                <option value={period.key} key={period.key}>
                  {period.label}
                </option>
              ))}
            </Select>
          </Col>
          <Col xs={5}>
            <BranchSelectSimple
              name='store'
              id={`store-${type}`}
              user={user}
              translate={translate}
              onChange={this.handleChange}
              noValueLabel={translate('analytics.allBranches')}
              value={branchFilter}
            />
          </Col>
          <Col xs={2}>
            <div className='circular wrap-click'>
              {type === 1 && (
                <Link
                  to='/most-accessed-web'
                  title={translate('analytics.title.most-accessed')}
                  alt={translate('analytics.title.most-accessed')}
                  className='color-text'
                >
                  <i className='plus' />
                </Link>
              )}
              {type === 2 && (
                <Link
                  to='/most-accessed-mobile'
                  title={translate('analytics.title.most-accessed')}
                  alt={translate('analytics.title.most-accessed')}
                  className='color-text'
                >
                  <i className='plus' />
                </Link>
              )}
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default MostAccessedView
